import React, { useState } from "react";
import { Calculator, TrendingUp } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import "./Calculator.css";

export default function InvestmentCalculator() {
  const plans = [
    { name: "Dairy Farm", rate: 24 },
    { name: "Gold and Silver", rate: 28 },
    { name: "RealEstate", rate: 24 },
    {name:"Agriculture",rate:30}
  ];

  const [amount, setAmount] = useState("");
  const years=1;
  const [selectedPlan, setSelectedPlan] = useState(plans[0]);
  const [returns, setReturns] = useState(null);
  const [breakdown, setBreakdown] = useState(null);

  const handleCalculate = () => {
    if (!amount || !years) {
      alert("Please enter amount and duration");
      return;
    }

    const rate = selectedPlan.rate / 100;
    const total = amount * Math.pow(1 + rate,1);
    const profit = total - amount;

    setReturns(total.toFixed(2));
    setBreakdown({
      invested: parseFloat(amount).toFixed(2),
      profit: profit.toFixed(2),
      total: total.toFixed(2),
      years,
    });
  };

  return (
    <div className="calc-page" id="calculator">
      {/* Left Side - Calculator */}
      <motion.div
        className="calc-card"
        initial={{ opacity: 0, y: 60 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
      >
        <div className="calc-header">
          <Calculator className="calc-icon" />
          <h2>Investment Calculator</h2>
        </div>

        <div className="form-group">
          <label>Investment Amount (₹)</label>
          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="Enter amount"
          />
        </div>

        <div className="form-group">
          <label>Duration (it will calculate only for "1" year)</label>
          <input
            type="number"
            value={1}
            //onChange={(e) => setYears(e.target.value)}
            placeholder="1"
          />
        </div>

        <div className="form-group">
          <label>Investment Plan</label>
          <select
            value={selectedPlan.name}
            onChange={(e) =>
              setSelectedPlan(plans.find((p) => p.name === e.target.value))
            }
          >
            {plans.map((plan) => (
              <option key={plan.name} value={plan.name}>
                {plan.name} ({plan.rate}%)
              </option>
            ))}
          </select>
        </div>

        <motion.button
          className="calc-btn"
          onClick={handleCalculate}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Calculate
        </motion.button>
      </motion.div>

      {/* Right Side - Results */}
      <AnimatePresence>
        {returns && breakdown && (
          <motion.div
            className="result-card"
            initial={{ opacity: 0, x: 60 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <div className="result-header">
              <TrendingUp className="result-icon" />
              <h2>Investment Summary</h2>
            </div>

            <div className="breakdown">
              <div className="break-item">
                <span className="label">Invested Amount:</span>
                <span className="value">₹{breakdown.invested}</span>
              </div>
              <div className="break-item">
                <span className="label">Tenure:</span>
                <span className="value">1 year</span>
              </div>
              <div className="break-item">
                <span className="label">Returns Earned:</span>
                <span className="value profit">₹{breakdown.profit}</span>
              </div>
              <div className="break-item total">
                <span className="label">Total Value:</span>
                <span className="value total-value">₹{breakdown.total}</span>
              </div>
            </div>

            <p className="plan-info">
              ({selectedPlan.name} @ {selectedPlan.rate}% annual interest)
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
